export enum AchBannerTextVariant {
  Variant = 'variant',
  Control = 'control',
}
